<template>
  <Box
    title="计量检测"
    :SearchParams="tabsIndex == 0 ? IsSee : IsSeeSecond"
    @SearchParams="tabsIndex == 0 ? (IsSee = true) : (IsSeeSecond = true)"
  >
    <van-tabs
      @click="propconfirm"
      swipeable
      background="rgba(0,0,0,0)"
      line-width="20px"
      v-model="tabsIndex"
    >
      <van-tab :title="'检测计划(' + Total + '条)'">
        <LoadingFooter
          v-model="loading"
          :finished="finished"
          @load="onLoad"
          @scroll="IsSee=false"
        >
          <transition-group name="fade">
            <div class="menu" v-show="IsSee" key="1">
              <Field
                title="设备名称"
                placeholder="请输入设备名称"
                @onMessage="(value) => (search.SBMC = value)"
              />
              <Field
                title="开始时间"
                placeholder="请选择"
                type="calendar"
                :DateMax="maxDate"
                @onMessage="(value) => (search.StartDate = value)"
              />
              <Field
                title="结束时间"
                placeholder="请选择"
                type="calendar"
                :DateMax="maxDate"
                @onMessage="(value) => (search.EndDate = value)"
              />
              <div class="search" @click="serach">查询</div>
            </div>
          </transition-group>
          <div
            class="ArrayItems items"
            v-for="item in list"
            @click="$router.push({ name: 'MeteringDetail', params: { item ,BtnUpdateState:true,BtnSaveState:false,ImgState:true,PageState:true } })"
          >
            <div>
              <img src="@/assets/img/Icon_1.png" />
              <div>
                <div>
                  <span class="ellipsis">{{ item.SBMC }}</span>
                  <img src="../../assets/img/right.png" />
                </div>
                <div>
                  <div>
                    <p>资产编号:</p>
                    <p>计量类型:</p>
                    <p>使用科室:</p>
                    <p>检测机构:</p>
                  </div>
                  <div>
                    <p class="ellipsis">{{ item.SBBH }}</p>
                    <p class="ellipsis">{{ item.JLLX }}</p>
                    <p class="ellipsis">{{ item.KSMC }}</p>
                    <p class="ellipsis">{{ item.JDJGMC }}</p>
                  </div>
                  <div class="button">
                    <div>计量</div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <span>下次计量日期</span>
              <span>{{ item.GMSJ }}</span>
            </div>
          </div>
        </LoadingFooter>
      </van-tab>
      <van-tab :title="'已检测(' + TotalSecond + '条)'">
        <LoadingFooter
          v-model="loadingSecond"
          :finished="finishedSecond"
          @load="onLoadSecond"
          @scroll="IsSeeSecond=false"
        >
          <transition name="fade">
            <div class="menu" v-show="IsSeeSecond" key="1">
              <Field
                title="设备名称"
                placeholder="请输入设备名称"
                @onMessage="(value) => (searchSecond.SBMC = value)"
              />
              <Field
                title="证书编号"
                placeholder="请输入证书编号"
                @onMessage="(value) => (searchSecond.ZSBH = value)"
              />
              <Field
                title="开始时间"
                placeholder="请选择"
                type="calendar"
                :DateMax="maxDate"
                @onMessage="(value) => (searchSecond.StartDate = value)"
              />
              <Field
                title="结束时间"
                placeholder="请选择"
                type="calendar"
                :DateMax="maxDate"
                @onMessage="(value) => (searchSecond.EndDate = value)"
              />
              <div class="search" @click="serach">查询</div>
            </div>
          </transition>
          <div
            class="ArrayItems items"
            v-for="item in listSecond"
            @click="$router.push({ name: 'MeteringDetail', params: { item,BtnUpdateState:item.JLZT=='0',BtnSaveState:item.JLZT=='0',ImgState:item.JLZT=='0',PageState:false } })"
          >
            <div>
              <img src="@/assets/img/Icon_1.png" />
              <div>
                <div>
                  <span class="ellipsis">{{ item.SBMC }}</span>
                  <img src="../../assets/img/right.png" />
                </div>
                <div>
                  <div>
                    <p>证书编号:</p>
                    <p>计量类型:</p>
                    <p>使用科室:</p>
                    <p>检测机构:</p>
                  </div>
                  <div>
                    <p class="ellipsis">{{ item.ZSBH }}</p>
                    <p class="ellipsis">{{ item.JLLX }}</p>
                    <p class="ellipsis">{{ item.KSMC }}</p>
                    <p class="ellipsis">{{ item.JDJGMC }}</p>
                  </div>
                  <div class="button">
                    <div>{{ item.JLZT === "0" ? "修改" : "查看" }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <span>计量检测时间</span>
              <span>{{ item.JLSJ }}</span>
            </div>
          </div>
        </LoadingFooter>
      </van-tab>
    </van-tabs>
  </Box>
</template>

<script>
import { ExistsEdorIng } from "../../../tool/api/api.js";
import { Tab, Tabs } from "vant";
import Box from "@/components/commonBox/commonBox";
import Field from "../../components/field/field";
import LoadingFooter from "../../components/loadingFooter/loadingFooter";
export default {
  name: "MeteringList",
  data() {
    return {
      search: {
        SBMC: null,
        StartDate: null,
        EndDate: null,
      },
      searchSecond: {
        SBMC: null,
        ZSBH: null,
        StartDate: null,
        EndDate: null,
      },
      loading: true,
      finished: false,
      list: [],
      touchStartY: 0,
      IsSee: false,
      page: 10,
      Total: 0,
      tabsIndex: 0, //选项卡默认选中
      listSecond: [], //已执行列表
      loadingSecond: false,
      finishedSecond: false,
      pageScond: 1,
      TotalSecond: 0,
      touchStartYSecond: 0, //已执行滚动条滚动数值
      IsSeeSecond: false, //已执行 是否展示
      maxDate:new Date("2050-12-31"),
    };
  },
  components: {
    Box,
    Field,
    LoadingFooter,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  activated() {
    this.serach();
  },
  methods: {
    // onScroll(value) {
    //   if (value > this.touchStartY) {
    //     this.touchStartY = value;
    //     this.IsSee = false;
    //   } else if (this.touchStartY - value > 200) {
    //     this.touchStartY = value;
    //     this.IsSee = true;
    //   }
    // },
    serach() {
      if (this.tabsIndex === 0) {
        this.IsSee = false;
        this.list = [];
        this.page = 1;
        this.loadDataDefault();
      } else {
        this.IsSeeSecond = false;
        this.listSecond = [];
        this.pageScond = 1;
        this.loadDataSecondDefault();
      }
    },
    onLoad() {
      if (!this.loading && !this.finished) {
        this.page += 1;
        this.loadDataDefault();
      }
    },
    loadDataDefault() {
      this.$post("api/Metering/MeteringList", {
        JLZT: this.tabsIndex,
        JLLX: 2,
        SBMC: this.search.SBMC,
        StartDate: this.search.StartDate,
        EndDate: this.search.EndDate,
        pageIndex: this.page,
        pageSize: 10,
      }).then((result) => {
        this.Total = result.Total;
        for (let i = 0; i < result.MeteringList.length; i++) {
          this.list.push(result.MeteringList[i]);
        }
        if (this.page * 10 > this.Total) {
          this.loading = false;
          this.finished = true;
        } else this.loading = false;
      });
    },
    /*************************已检测**************************************/
    propconfirm() {
      if (this.tabsIndex == 0) {
        this.IsSee = false;
        this.list = [];
        this.loadDataDefault();
      } else {
        this.IsSeeSecond = false;
        this.listSecond = [];
        this.loadDataSecondDefault();
      }
    },
    loadDataSecondDefault() {
      this.$post("api/Metering/MeteringList", {
        JLZT: this.tabsIndex,
        JLLX: 2,
        ZSBH:this.searchSecond.ZSBH,
        SBMC: this.searchSecond.SBMC,
        StartDate: this.searchSecond.StartDate,
        EndDate: this.searchSecond.EndDate,
        pageIndex: this.pageScond,
        pageSize: 10,
      }).then((result) => {

        this.TotalSecond = result.Total;
        for (let i = 0; i < result.MeteringList.length; i++) {
          this.listSecond.push(result.MeteringList[i]);
        }
        if (this.pageScond * 10 > this.TotalSecond) {
          this.loadingSecond = false;
          this.finishedSecond = true;
        } else this.loadingSecond = false;
      });
    },
    onLoadSecond() {
      if (!this.loadingSecond && !this.finishedSecond) {
        this.pageScond += 1;
        this.loadDataSecondDefault();
      }
    },
    // onScrollSecond(value) {
    //   if (value > this.touchStartYSecond) {
    //     this.touchStartYSecond = value;
    //     this.IsSeeSecond = false;
    //   } else if (this.touchStartYSecond - value > 200) {
    //     this.touchStartYSecond = value;
    //     this.IsSeeSecond = true;
    //   }
    // },
  },
};
</script>

<style scoped lang="scss">
.menu {
  background: $BACKGROUND-COLOR;
  border-radius: 12px;
  padding: 0 29px 35px 40px;
  box-sizing: border-box;
  margin-bottom: 20px;
  margin-top: 100px;

  .items {
    display: flex;
    height: 112px;
    align-items: center;
    border-bottom: 2px solid #f3f3f3;

    span {
      flex: 1;
    }

    input {
      width: 215px;
      font-size: 29px;
      text-align: center;

      &::-webkit-input-placeholder {
        color: #858585;
      }
    }
  }

  .search {
    height: 88px;
    background: $THEME-COLOR;
    border-radius: 8px;
    font-size: 32px;
    color: $TEXT-LIGHT-COLOR;
    text-align: center;
    line-height: 88px;
    margin-top: 35px;
  }
}

.items {
  background: $BACKGROUND-COLOR;
  border-radius: 16px;
  margin-bottom: 20px;
  padding-bottom: 20px;

  & > div {
    &:first-child {
      display: flex;
      padding: 34px 16px 27px 26px;
      box-sizing: border-box;
      border-bottom: 2px solid #efefef;

      img {
        width: 150px;
        height: 150px;
        border-radius: 4px;
      }

      & > div {
        &:nth-child(2) {
          margin-left: 16px;
          flex: 1;

          & > div {
            display: flex;

            &:first-child {
              margin-bottom: 18px;
              display: flex;

              span:first-child {
                color: $TEXT-DARK-COLOR;
                font-weight: bold;
                font-size: 32px;
                flex: 1;
                width: 208px;
              }

              span:nth-child(2) {
                color: $TEXT-DARK-COLOR;
                font-size: 28px;
                margin-left: 10px;
                width: 158px;
                text-align: right;
              }

              img {
                width: 32px;
                height: 32px;
                margin-left: 10px;
              }
            }

            &:nth-child(2) {
              p {
                color: #999;
                font-size: 26px;
                line-height: 45px;
                height: 45px;
              }

              & > div:nth-child(2) {
                p {
                  width: 200px;
                }
              }
            }
          }

          .button {
            margin-left: 10px;
            margin-top: 20px;

            div {
              width: 152px;
              height: 60px;
              border-radius: 30px;
              background: $THEME-COLOR;
              font-size: 26px;
              color: #fff;
              text-align: center;
              line-height: 60px;
              margin-bottom: 12px;
            }
          }
        }
      }
    }

    &:last-child {
      margin-top: 16px;
      padding: 0 26px 0 31px;
      box-sizing: border-box;
      display: flex;

      span {
        color: #999;
        font-size: 26px;

        &:first-child {
          flex: 1;
        }
      }
    }
  }
}

.listLength {
  font-size: 29px;
  color: #4a4a4a;
  margin-bottom: 18px;
  margin-left: 30px;

  span {
    margin-left: 20px;
    color: $THEME-COLOR;
    font-weight: bold;
  }
}

.ArrayItems:nth-child(2) {
  margin-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/page/Metering/MeteringList.vue